import { render } from "./VerifikasiPALama.vue?vue&type=template&id=1d7e884e"
import script from "./VerifikasiPALama.vue?vue&type=script&lang=js"
export * from "./VerifikasiPALama.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__